module.exports = __webpack_public_path__ + "static/media/happy.7cfeaad5.svg";